import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';

import { Container } from '../../Container';
import { ArrowRight, ArrowLeft } from '../../Arrow';
import { Title } from './title';
import { CardItem } from './card-item'; 

import './content-card.css';

export const ContentCard = ({ pageData }) => {
  const [contentVisibility, setContentVisibility] = useState(null);
  const ref = useRef(null);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: (pageData && pageData[0]) !== null ? pageData[0].cardLists.length : 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
            fade: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    
  }, [contentVisibility]);

  useEffect(() => {
    if (ref.current && ref.current.slickNext && ref.current.slickPrev) {}
  }, []);
  return (pageData && pageData[0]) !== null ? (
    <div  className="relative content-card">
      <Title title={pageData[0].title} titleNotes={pageData[0].titleNotes}/>
      <Container>
        <div className="prev" onClick={() => ref.current.slickPrev()}>
          <ArrowLeft />
        </div>
        <Slider ref={ref} {...settings}>
          {pageData[0].cardLists !== null &&
            pageData[0].cardLists.map((item, index) => (
              <CardItem key={index} item={item} index={index} contentVisibility={contentVisibility} setContentVisibility={setContentVisibility} />
            ))}
        </Slider>
        <div className="next" onClick={() => ref.current.slickNext()}>
          <ArrowRight />
        </div>
      </Container>
    </div>
  ) : null;
};